module.exports = __webpack_public_path__ + "images/f454d1c6724b7f66ba81954e029b83fd-IMG_8172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8172.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8172.jpg
// module chunks = 0